module.exports = __webpack_public_path__ + "images/backgrounds/cosmos/small.0646808c900b7409dbeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/cosmos/small.jpg
// module id = ZeZq
// module chunks = 13